// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2K6lW","content":"GlobalSearch_content__3_xox"};